import { render, staticRenderFns } from "./VuesticLayout.vue?vue&type=template&id=7aa8f30f&"
import script from "./VuesticLayout.vue?vue&type=script&lang=js&"
export * from "./VuesticLayout.vue?vue&type=script&lang=js&"
import style0 from "./VuesticLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VuesticLayout.vue"
export default component.exports